import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { AslibLoadingService } from '@aslib/loading';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { ShowFile } from '../../shared/helpers/show-file';
import { CadastrarValorMensalDistribuicaoService } from '../shared/service/cadastra-valor-mensal-distribuir..service';
import { CadastraValorMensalDistribuicao, CadastraValorMensalDistribuicaoModelView } from '../shared/model/cadastra-valor-mensal-distribuir.model';
import { BaseConfig } from '../../shared/service/base-config.service';
import { Router } from '@angular/router';
import { AslibTitleService } from '@aslib/components';

@Component({
  selector: 'sarf-cadastra-valor-mensal-distribuir',
  templateUrl: './cadastra-valor-mensal-distribuir.component.html'
})


export class CadastraValorMensalDistribuir implements OnInit {
  [x: string]: any;
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  showFile: ShowFile;

  dadosCadastraValorMensalDistribuir: CadastraValorMensalDistribuicao;
  cadastraValorMensalDistribuivaoModelView: CadastraValorMensalDistribuicaoModelView;

  usuarioLogado: any;

  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  

  constructor(
    private router: Router,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly cadastrarValorMensalDistribuicaoService: CadastrarValorMensalDistribuicaoService,
    private baseConfig: BaseConfig,
    private aslibTitleService: AslibTitleService,
        private cd: ChangeDetectorRef
  ) {
    modalManagerHelper.parent = this;
    this.cadastraValorMensalDistribuivaoModelView = new CadastraValorMensalDistribuicaoModelView();
    this.dadosCadastraValorMensalDistribuir =  new CadastraValorMensalDistribuicao();
    
    this.usuarioLogado = this.baseConfig.getUsuarioLogado();
  }

  //metodos de ciclo de vida do componente
ngAfterViewInit() {
  setTimeout(() => {
    this.aslibTitleService.Text = "Valor dos Royalties a Distribuir";
    this.aslibTitleService.SubText = "Cadastrar"
    this.cd.detectChanges(); 
  });
}
ngOnInit() {

}
unSubscribe() {
  this._aslibLoadingService.complete();
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}

//metodos de negócio
formCadastroValorMensalDistribuir = new FormGroup({
  dataReferenciaDistribuicao: new FormControl('', Validators.required),
  valorMensalDistribuicao: new FormControl('', [Validators.required, Validators.min(0.01)]),
});

validarCadastroValorMensalDistribuicao() : boolean {
const data = this.dataReferenciaDistribuicao;

  return this.isValidDate(this.mesAnoToMesDiaAno(data));             
}

setaDados() {
  this.dadosCadastraValorMensalDistribuir.DataReferenciaDistribuicao = this.dataReferenciaDistribuicao;
  this.dadosCadastraValorMensalDistribuir.ValorMensalDistribuicao = this.valorMensalDistribuicao;
  this.dadosCadastraValorMensalDistribuir.LoginUsuario = this.usuarioLogado.Login;
}

salvarValorMensalDistribuicao(modal: AslibModalComponent){

  if (!this.validarCadastroValorMensalDistribuicao()) {
    // inserir modal de alerta
    return;
  }

  this.setaDados();
  this.registrarValorMensalDistribuicao();
}

exibirSucesso(mensagem:string){         
  this._aslibLoadingService.complete();
  new AslibModalComponent(this._aslibModalService).open(
    {
      title: 'Mensagem',
      text: mensagem,
      type: 'info'
    }
  );
} 

exibirError(mensagem:string){
  this._aslibLoadingService.complete();
  new AslibModalComponent(this._aslibModalService).open(
    {
      title: 'Mensagem',
      text: mensagem,
      type: 'Info'
    }
  );
} 

public isValidDate(dateString: string): boolean {
  const date = new Date(dateString)
  // Verifica se a data criada é "Invalid Date"
  return !isNaN(date.getTime());
}
mesAnoToMesDiaAno(input: string): string {
  const match = input.trim().match(/^(\d{1,2})\/(\d{4})$/);
  if (!match) {
    throw new Error(`Formato inválido: "${input}". Use "MM/YYYY".`);
  }

  const month = Number(match[1]);
  const year = match[2]; // manter como string de 2 dígitos

  if (month < 1 || month > 12) {
    throw new Error(`Mês inválido: ${month}. Deve estar entre 01 e 12.`);
  }

  const mm = month.toString().padStart(2, "0");
  const dd = "01"; // dia fixo
  const yyyy = year.padStart(4, "0");

  return `${mm}/${dd}/${yyyy}`;
}
irPraConsulta(){
   this.router.navigate(['/royalts/sarf-consulta-valor-mensal-distribuir']);
 }
public limpar(){
    this.formCadastroValorMensalDistribuir.reset();

    this.dataReferenciaDistribuicao = ''
    this.valorMensalDistribuicao = 0;
}
limparConsulta(){
      this.formCadastroValorMensalDistribuir.reset();
      this.filtro = { ...this.filtroVazio };
 }


//Metodos de interação com o serviço
registrarValorMensalDistribuicao(){
  
  this._aslibLoadingService.start();
    this.subscription =  this.cadastrarValorMensalDistribuicaoService
      .registrarValorMensalDistribuicao(this.dadosCadastraValorMensalDistribuir)
      .subscribe(          
        data => {
          if(data.Data){
            this.exibirSucesso(data.Message);
            this.limpar();
            this.irPraConsulta();
          }else{
            this.exibirError(data.Message);
          }        
        },
        (error: any) => {
          this.exibirError(error.Message);
          
        },
        () => {
          this.unSubscribe(); 
        }
      );
}

}



// WEBPACK FOOTER //
// ./src/app/royalts/valor-mensal-distribuir/cadastra-valor-mensal-distribuir.component.ts